import { LinearProgress, Box, Typography } from '@mui/material';

interface ProgressLineProps {
    total: number; // Tổng số
    value: number; // Giá trị hiện tại
    label?: string;
    showPercentage?: boolean;
    showValues?: boolean; // Hiển thị value/total thay vì %
    color?: string;
    height?: number;
    backgroundColor?: string;
    barColor?: string;
}

export default function ProgressLine({
    total,
    value,
    label,
    showPercentage = true,
    showValues = false,
    color = 'primary',
    height = 8,
    backgroundColor,
    barColor
}: ProgressLineProps) {
    // Tính phần trăm từ total và value
    const percentage = total > 0 ? Math.round((value / total) * 100) : 0;

    return (
        <Box sx={{ width: '100%' }}>
            {/* Label và Percentage/Values */}
            {(label || showPercentage || showValues) && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    {label && (
                        <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 500, color: '#262626' }}>
                            {label}
                        </Typography>
                    )}
                    {showValues ? (
                        <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 600, color: '#000' }}>
                            {value}/{total}
                        </Typography>
                    ) : showPercentage && (
                        <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 600, color: '#032F9C' }}>
                            {percentage}%
                        </Typography>
                    )}
                </Box>
            )}

            {/* Progress Bar */}
            <LinearProgress
                variant="determinate"
                value={percentage}
                sx={{
                    color: color,
                    height: height,
                    borderRadius: 10,
                    backgroundColor: backgroundColor || '#E0E0E0',
                    '& .MuiLinearProgress-bar': {
                        borderRadius: 10,
                        backgroundColor: barColor
                    }
                }}
            />
        </Box>
    );
}